import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const transactionsRoutes: Routes = [
  {
    path: 'transactions',
    loadComponent: () =>
      import('./transactions.component').then((c) => c.TransactionsComponent),
    canActivate: [AuthGuard],
  },
];
